import { ILocales } from "../../i18n/ILocales";
import { authStore } from "../../stores/AuthStore";
import { generalStore } from "../../stores/GeneralStore";

const privacyPolicy: Record<ILocales, string> = {
    de: "https://pharmgenetix-burgenland.at/datenschutz/",
    en: "https://pharmgenetix-burgenland.at/privacy-policy/",
};

const imprint: Record<ILocales, string> = {
    de: "https://pharmgenetix-burgenland.at/impressum/",
    en: "https://pharmgenetix-burgenland.at/legal-notice/",
};

const contact = {
    doctor: "https://pharmgenetix-burgenland.at/contact/",
    patient: "https://pharmgenetix-burgenland.at/contact/",
    admin: "https://pharmgenetix-burgenland.at/contact/",
};

const home = "https://pharmgenetix-burgenland.at/";

const currentLocale = (): ILocales => generalStore.locale ?? "de";

export const ExternalLinks = {
    home: () => home,
    privacyPolicy: () => privacyPolicy[currentLocale()] ?? privacyPolicy.de,
    imprint: () => imprint[currentLocale()] ?? imprint.de,
    contact: () => {
        if (authStore.isDoctor) return contact.doctor;
        if (authStore.isAdmin) return contact.admin;
        return contact.patient;
    },
};
